import React, { Component } from "react";
import PropTypes from "prop-types";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import { styled } from "@mui/material/styles";

import EventBus from "~/libs/eventBus";
import RightSidebarContent from "./RightSidebarContent";

const StyledToolbar = styled(Toolbar)(props => {
  let backgroundColor = props.theme.palette.mbgreen[0];
  if (props.isDlsActive) {
    backgroundColor = props.theme.palette.mborange[0];
  }
  if (props.isPresentationActive) {
    backgroundColor = props.theme.palette.prblue[1];
  }

  return {
    "&.MuiToolbar-root": {
      backgroundColor,
      justifyContent: "center",
      height: "2.4rem",
      width: "300px",
      color: "white",
      fontSize: props.theme.typography.pxToRem(18),
      transition: "none !important",
      "-webkit-transform-style": "preserve-3d",
      "-webkit-backface-visibility": "hidden",
      "-webkit-transform": "translate3d(0,0,0)"
    },
    "&:focus-visible": {
      // "--dsb-outline-color": "green",
      outline: props.theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

StyledToolbar.whyDidYouRender = true;

const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    transition: "none !important",
    "-webkit-transform-style": "preserve-3d",
    "-webkit-backface-visibility": "hidden",
    "-webkit-transform": "translate3d(0,0,0)"
  },
  "& .MuiDrawer-paperAnchorDockedRight": {
    position: "absolute",
    border: "none",
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px"
  }
});

class RightSidebar extends Component {
  static whyDidYouRender = true;

  constructor(props) {
    super(props);

    this.getSlotProps = this.getSlotProps.bind(this);
    this.zoomToRefit = this.zoomToRefit.bind(this);
  }

  getSlotProps() {
    const { isOpen } = this.props;
    return {
      transition: { in: isOpen, timeout: 450, onEntering: this.zoomToRefit, onExiting: this.zoomToRefit },
      paper: { style: { width: isOpen ? 300 : 0 } }
    };
  }

  zoomToRefit() {
    const { isDlsActive } = this.props;
    const params = {
      direction: "top",
      padding: { top: 48 }
    };

    if (isDlsActive) {
      EventBus.dispatch("zoomToRefit", "main", params);
    } else {
      EventBus.dispatch("zoomToRefit", "main");
    }

    EventBus.dispatch("zoomToRefit", "embedded", params);
  }

  render() {
    const {
      isOpen,
      toggleSidebarRight,
      isMaterialVisible,
      isRightSidebarVisible,
      isDlsActive,
      isPresentationActive,
      isDocked
    } = this.props;

    return (
      isMaterialVisible &&
      isRightSidebarVisible && (
        <StyledDrawer
          slotProps={this.getSlotProps()}
          anchor="right"
          className="rightSidebar"
          open={isOpen}
          variant={isDocked ? "persistent" : "temporary"}
          onClose={toggleSidebarRight}
        >
          <StyledToolbar isDlsActive={isDlsActive} isPresentationActive={isPresentationActive} variant="dense">
            Material
          </StyledToolbar>
          <RightSidebarContent />
        </StyledDrawer>
      )
    );
  }
}

RightSidebar.propTypes = {
  isDlsActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isDocked: PropTypes.bool.isRequired,
  isMaterialVisible: PropTypes.bool.isRequired,
  isRightSidebarVisible: PropTypes.bool.isRequired,
  toggleSidebarRight: PropTypes.func.isRequired,
  isPresentationActive: PropTypes.bool.isRequired
};

export default RightSidebar;
